import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { Grid, Divider } from '@mui/material';
import BracketGraph from 'components/BracketGraph';
import CustomButton from 'components/Button';
import ImageBox from 'components/ImageBox';
import Text from 'components/Text';
import ConditionalDropdowns from 'pages/calculator/ConditionalDropdowns';
import { authPostRequest } from 'Api/api';
import Loader from 'components/Loader';
import SuccessError from 'components/SuccessError';
import { ArrowForward } from '@mui/icons-material/index';
import PropTypes from 'prop-types';
import BackButton from 'components/BackButton';

import {
  clearBracketOptionsData,
  setAllInputData,
  setBaracketImagesWithPrices,
  setBracketOptions,
  setbracketMaterialPrices
} from 'reduxStore/bracketOptionsSlice';
import {
  getImagesDataWithMaterialsPrices,
  getQuotaionDataForEdit,
  outputLabels
} from 'pages/calculator/calculatorUtils';
import { clearCalculationsData, setAllOutputs } from 'reduxStore/calculationsSlice';
import SortDropdown from 'components/SortDropdown';
import { BRACKET_MATERIALS } from 'constant/enums';
import BracketsCart from 'components/BracketsCart';
import { snowBracketsData } from 'utils/imageData';
import RoofSectionHeader from 'components/RoofSectionHeader';
import { isAdmin, isUser, isValidNumber } from 'utils/utils';
import SaveScreenshot from 'components/SaveScreenshot';
import { useRef } from 'react';
import { getAreRoofingSqrsValid, getIsSnowBracket, getPrices } from './BracketCalcHelper';
import SnowloadImage from 'components/SnowloadImage';

const getValidValue = (value) => {
  if (isNaN(value)) return 0;
  else return value;
};

const Calculator = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const roofState = location.state;
  const roofData = roofState?.roofData;
  const roofName = roofData?.name?.trim();
  const roofDescription = roofData?.description?.trim();
  const projectId = roofState?.projectId;
  const projectName = roofState?.projectName;
  const roofId = roofData?.id;

  const [currentOptions, setCurrentOptions] = useState();
  const [darwGraph, setDrawGraph] = useState(false);
  const [isCalcInEditMode, setIsCalcInEditMode] = useState(false);
  const [successMessage, setSuccessMessage] = useState([]);
  const [errorMessage, setErrorMessage] = useState([]);
  const [showLoader, setShowLoader] = useState(false);
  const [showAlertBar, setShowAlertBar] = useState(false);
  const [bracketQuotationId, setBracketQuotationId] = useState(null);
  const [enableFinishBtn, setEnableFinishBtn] = useState(null);
  const [sortByMaterial, setSortByMaterial] = useState(BRACKET_MATERIALS.STEEL);
  const [images, setImages] = useState([]);
  const [snowLoadImage, setSnowLoadImage] = useState(false);
  const { userData, storeData, adminAccess } = useSelector((store) => store.auth);

  const contentRef = useRef(null);

  const storeID = adminAccess
    ? storeData?.id
    : isUser(userData?.roles) || isAdmin(userData?.roles)
      ? userData?.storesList[0]?.storeId
      : null;

  const { calcResults } = useSelector((store) => store.calculations);
  const {
    inputValues,
    selectedDropdownValues,
    bracketMaterialPrices,
    bracketImagesWithPrices,
    selectedImages
  } = useSelector((store) => store.bracketOptions);

  const { readOnly } = useSelector((store) => store.auth);
  const dispatch = useDispatch();

  const getQuotaion = async () => {
    try {
      setShowLoader(true);

      const quotaionRes = await authPostRequest('getBracketQuotationByRoofType', {
        roofSectionId: roofId
      });
      if (quotaionRes) {
        if (quotaionRes.resStatus === 1) {
          const quotaion = quotaionRes.bracketQuotationsList[0];
          setBracketQuotationId(quotaion.bracketQuotationId);
          dispatch(
            setAllInputData({
              inputData: {
                groundSnowLoad: quotaion.groundSnowLoad,
                rainLoad: quotaion.rainLoad,
                roofSlope: quotaion.roofSlope,
                verticalExposure: quotaion.verticalExposure,
                horizontalExposure: quotaion.horizontalExposure,
                roofType: quotaion.roofType,
                constructionType: quotaion.constructionType,
                bracketType: quotaion.snowBracketType,
                bracketMaterial: quotaion.snowBracketMaterial,
                sheathing: quotaion.roofSheathingType,
                fastenerType: quotaion.fastenerType,
                manufacturer: quotaion.manufacturer,
                model: quotaion?.model,
                gauge: quotaion?.gauge,
                mountTo: quotaion?.mountTo,
                installationMethod: quotaion?.installationMethod,
                numberOfRoofingSqrs: quotaion?.roofingSquares
              }
            })
          );
          dispatch(
            setAllOutputs({
              outputData: {
                requiredSnowBracketsPerSquare: quotaion.reqSnowBrktPerSqrArg,
                calculatedSnowBracketsPerSquare: quotaion.actualSnowBracketPerSquare,
                horizontalEaveSpacing: quotaion.horizontalEaveSpacing,
                horizontalFieldSpacing: quotaion.horizontalFieldSpacing,
                verticalSpacing: quotaion.verticalSpacing,
                numberOfCoursesHorizontally: quotaion.numOfCoursesHorizontalAtEave,
                numberOfCoursesVertically: quotaion.numOfCoursesVertically,
                totalBracketsForRoofingSquares: quotaion.totalBracketsForRoofingSquares
              }
            })
          );
          setIsCalcInEditMode(true);
        }
        setShowLoader(false);
      }
    } catch (err) {
      setShowLoader(false);
      console.log('error', err);
    }
  };

  const getBracketswithStorePrice = async () => {
    try {
      const bracketPriceRes = await authPostRequest('getBracketsWithStorePrice', {
        storeId: storeID,
        bracketTypeId: 59 // for snow bracket types
      });
      if (bracketPriceRes.resStatus === 1) {
        const bracketsPriceDataList = bracketPriceRes.bracketsList;
        const bracketImagesWithPrices = getImagesDataWithMaterialsPrices(
          snowBracketsData,
          bracketsPriceDataList,
          false,
          selectedDropdownValues['Roof Type'],
          selectedDropdownValues['Construction Type']
        );
        dispatch(setbracketMaterialPrices({ bracketsPriceDataList }));
        dispatch(setBaracketImagesWithPrices({ bracketImagesWithPrices }));
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    if (darwGraph) {
      setEnableFinishBtn(true);
    } else {
      setEnableFinishBtn(false);
    }
  }, [darwGraph, inputValues?.numberOfRoofingSqrs?.value]);

  useEffect(() => {
    if (isCalcInEditMode) {
      const bracktOptionsDataForStore = getQuotaionDataForEdit(inputValues, selectedDropdownValues);
      dispatch(
        setBracketOptions({
          bracketOptionsData: {
            inputsData: bracktOptionsDataForStore?.inputs,
            selectedKeyData: bracktOptionsDataForStore?.dropdowns,
            currentLevel: bracktOptionsDataForStore?.currentLevel,
            currentData: bracktOptionsDataForStore?.currentData,
            selectedImages: bracktOptionsDataForStore?.imgsDataArr
          }
        })
      );
    }
  }, [isCalcInEditMode]);

  // to show or hide graph based on calculation results
  useEffect(() => {
    if (
      isValidNumber(calcResults.horizontalEaveSpacing) &&
      isValidNumber(calcResults.verticalSpacing) &&
      getAreRoofingSqrsValid(inputValues?.numberOfRoofingSqrs?.value)
    ) {
      setDrawGraph(true);
    } else {
      setDrawGraph(false);
    }
  }, [calcResults]);

  // to clear store slice for bracketOptions
  useEffect(() => {
    if (!storeID) {
      navigate('/Stores');
    } else if (!projectId) {
      navigate('/storeInfo/projects');
    } else if (!roofId || roofId == null || roofId == undefined) {
      navigate('/storeInfo/roof-section');
    }
    // get quotation
    getBracketswithStorePrice();
    getQuotaion();
    return () => {
      dispatch(clearBracketOptionsData());
      dispatch(clearCalculationsData());
    };
  }, []);

  const resultsHTML = [];
  const outputObjects = [];

  for (const key in calcResults) {
    // we don't need to shwo this for now
    if (key === 'reqSnowBrktPerSqrArg') continue;
    // html element to render i.e output lable and vlaue under the graph
    const htmlElement = (
      <Grid
        display="flex"
        justifyContent="space-between"
        sx={{ mt: '1vh', mx: '1vh', width: '500px' }}>
        <Text key={key} sx={{ fontWeight: 'bold', width: '450px' }}>
          {outputLabels[key]}
        </Text>
        {/* was needed to roung up this differently */}
        {key === 'actualSnowBracketPerSquare' || key === 'totalBracketsForRoofingSquares' ? (
          <Text key={key}>
            {isValidNumber(calcResults[key]) ? Math.ceil(calcResults[key]) : 'N/A'}
          </Text>
        ) : (
          <Text key={key}>
            {isValidNumber(calcResults[key]) ? parseFloat(calcResults[key])?.toFixed(2) : 'N/A'}
          </Text>
        )}
      </Grid>
    );
    // output object is created for tracking
    const outputObject = { label: outputLabels[key], value: calcResults[key] };
    // if  element already exist then find index and then update itinstead of pushing again
    const index = outputObjects.findIndex((output) => output.label === outputLabels[key]);
    if (index !== -1) {
      outputObjects.splice(index, 1, outputObject);
      resultsHTML.splice(index, 1, htmlElement);
    }
    // if not exists then push into the array
    if (calcResults[key] != 'error') {
      outputObjects.push(outputObject);
      resultsHTML.push(htmlElement);
    }
  }

  const submitQuotation = async () => {
    setShowAlertBar(false);
    setErrorMessage([]);
    setEnableFinishBtn(false);

    const { totalPrice, unitPrice } = getPrices(
      selectedImages,
      bracketImagesWithPrices,
      calcResults?.totalBracketsForRoofingSquares
    );

    const requestParams = {
      userId: userData.userId,
      storeId: storeID,
      bracketQuotationId: bracketQuotationId,
      roofSectionId: roofId,
      roofType: selectedDropdownValues['Roof Type'],
      constructionType: selectedDropdownValues['Construction Type'],
      bracketType: selectedDropdownValues['Snow Bracket Type'],
      bracketMaterial: selectedDropdownValues['Snow Bracket Material'],
      sheathingType: selectedDropdownValues['Sheathing'],
      fastenerType: selectedDropdownValues['Fastener Type'],
      manufacturer: selectedDropdownValues['Manufacturer'],
      model: selectedDropdownValues?.model,
      gauge: selectedDropdownValues?.gauge,
      mountTo: selectedDropdownValues['Mount To'],
      installationMethod: selectedDropdownValues['Installation Method'],
      groundSnowLoad: inputValues?.groundSnowLoad?.value,
      rainLoad: inputValues?.rainLoad?.value,
      roofSlope: inputValues?.roofSlope?.value,
      verticalExposure: inputValues?.verticalExposure?.value,
      horizontalExposure: inputValues?.horizontalExposure?.value,
      roofingSquares: inputValues && Math.ceil(inputValues?.numberOfRoofingSqrs?.value),
      requiredSnowBracketsPerSquare: null,
      calculatedSnowBracketsPerSquare: !isValidNumber(calcResults?.actualSnowBracketPerSquare)
        ? null
        : Math.ceil(calcResults?.actualSnowBracketPerSquare),
      horizontalEaveSpacing: !isValidNumber(calcResults?.horizontalEaveSpacing)
        ? null
        : calcResults?.horizontalEaveSpacing,
      horizontalFieldSpacing: !isValidNumber(calcResults?.horizontalFieldSpacing)
        ? null
        : calcResults?.horizontalFieldSpacing,
      verticalSpacing: !isValidNumber(calcResults?.verticalSpacing)
        ? null
        : calcResults?.verticalSpacing,
      numberOfCoursesHorizontally: !isValidNumber(calcResults?.numOfCoursesHorizontalAtEave)
        ? null
        : Math.ceil(calcResults?.numOfCoursesHorizontalAtEave),
      numberOfCoursesVertically: !isValidNumber(calcResults?.numOfCoursesVertically)
        ? null
        : Math.ceil(calcResults?.numOfCoursesVertically),
      totalBracketsForRoofingSquares: Math.ceil(calcResults?.totalBracketsForRoofingSquares),
      unitPrice: unitPrice,
      totalPrice: totalPrice
    };
    setShowLoader(true);
    try {
      const questionSaved = await authPostRequest('saveBracketQuotation', requestParams);
      window.scrollTo(0, 0);
      if (questionSaved) {
        if (questionSaved.resStatus === 1) {
          setSuccessMessage([questionSaved.resMessage]);
          setTimeout(() => {
            navigate(-1);
          }, 2000);
        } else {
          setEnableFinishBtn(true);
          setErrorMessage([questionSaved.resMessage]);
        }
        setShowAlertBar(true);
      }
      setShowLoader(false);
    } catch (err) {
      setShowLoader(false);
      setEnableFinishBtn(true);
      window.scrollTo(0, 0);
      console.log('error', err);
    }
  };

  useEffect(() => {
    if (!readOnly) {
      let images = [];
      let imagesData = [];
      if (currentOptions) {
        // check if the current options are of type brackets
        if (getIsSnowBracket(currentOptions)) {
          imagesData = getImagesDataWithMaterialsPrices(
            currentOptions,
            bracketMaterialPrices,
            sortByMaterial,
            selectedDropdownValues['Roof Type'],
            selectedDropdownValues['Construction Type']
          );
          images = <BracketImageOptionsUI imagesData={imagesData} />;
        } else {
          imagesData = currentOptions;
          images = imagesData?.map((imgData) => <ImageBox key={imgData.id} imgData={imgData} />);
        }
      }
      setImages(images);
    }
  }, [currentOptions, bracketMaterialPrices, sortByMaterial]);

  return (
    <Grid container>
      {showLoader && <Loader open={showLoader} />}
      {showAlertBar && (
        <SuccessError
          successMessage={successMessage}
          errorMessage={errorMessage}
          setShowAlertBar={setShowAlertBar}
        />
      )}
      <Grid item xs={12} display="flex" justifyContent="space-between">
        <BackButton
          onClick={() =>
            navigate('/StoreInfo/roof-section', {
              state: {
                index: {
                  id: projectId,
                  name: projectName,
                  description: roofState?.projectDescription
                }
              }
            })
          }
        />
        <BracketsCart />
      </Grid>
      <RoofSectionHeader
        roofId={roofId}
        projectId={projectId}
        roofName={roofName}
        price={roofData?.price}
        roofDescription={roofDescription}
        setErrorMessage={setErrorMessage}
        setSuccessMessage={setSuccessMessage}
        setShowAlertBar={setShowAlertBar}
        setShowLoader={setShowLoader}
        quotationTypeId={59}
      />
      <Grid item xs={12} display="flex" justifyContent="flex-end" sx={{ width: 400 }}>
        {getIsSnowBracket(currentOptions) && (
          <SortDropdown setSortByMaterial={setSortByMaterial} sortByMaterial={sortByMaterial} />
        )}
      </Grid>
      <Grid item xs={4} sx={{ width: 400 }}>
        <ConditionalDropdowns
          setSnowLoadImage={setSnowLoadImage}
          setDrawGraph={setDrawGraph}
          isEditMode={isCalcInEditMode}
          setIsCalcInEditMode={setIsCalcInEditMode}
          setCurrentOptions={setCurrentOptions}
        />
      </Grid>
      <Grid
        item
        spacing={4}
        xs={8}
        display="flex"
        sx={{
          minHeight: '75vh',
          flexWrap: 'wrap',
          py: 2,
          pl: 4,
          width: '100%',
          alignContent: 'flex-start'
        }}>
        {currentOptions && images}
        {snowLoadImage && <SnowloadImage />}
        {darwGraph && (
          <>
            <div id="bracket_results" style={{ width: '100%' }} ref={contentRef}>
              <BracketGraph
                eSpace={getValidValue(calcResults.horizontalEaveSpacing)}
                fSpace={getValidValue(calcResults.horizontalFieldSpacing)}
                vSpace={getValidValue(calcResults.verticalSpacing)}
              />
              {resultsHTML.length > 0 && <Grid justifyContent="space-between">{resultsHTML}</Grid>}
            </div>
            <SaveScreenshot
              setShowLoader={setShowLoader}
              enableBtn={readOnly || enableFinishBtn}
              displayText="Save Results"
              contentRef={contentRef}
            />
          </>
        )}
      </Grid>
      {!readOnly && (
        <Grid xs={12} display="flex" justifyContent="flex-end">
          <CustomButton
            sx={{ mt: 2, mb: 0, mx: 0 }}
            type="button"
            endIcon={<ArrowForward />}
            disabled={!enableFinishBtn}
            onClick={submitQuotation}>
            Finish Project
          </CustomButton>
        </Grid>
      )}
    </Grid>
  );
};

export default Calculator;

/**
 * This react component is for UI of brackets with recommended feature
 *
 */
const BracketImageOptionsUI = ({ imagesData }) => {
  const recImgs = imagesData?.filter((img) => img['1stRecommended'] || img['2ndRecommended']);
  const otherImgs = imagesData?.filter((img) => !img['1stRecommended'] && !img['2ndRecommended']);
  // creating html for both types of brackets
  const recImgsHtml = recImgs?.map((imgData) => <ImageBox key={imgData.id} imgData={imgData} />);
  const otherImgsHtml = otherImgs?.map((imgData) => (
    <ImageBox key={imgData.id} imgData={imgData} />
  ));
  return (
    <>
      <Grid
        item
        spacing={4}
        display="flex"
        sx={{
          minHeight: '75vh',
          backgroundColor: 'white',
          flexWrap: 'wrap',
          width: '100%',
          alignContent: 'flex-start'
        }}>
        {recImgsHtml?.length > 0 && (
          <>
            <Grid xs={12} sx={{ mt: 1, ml: 0.75 }}>
              <Text sx={{ fontSize: 24, color: 'grey' }}>Recommended</Text>
            </Grid>
            {recImgsHtml}
            <Grid xs={12} sx={{ mt: 1, ml: 0.75 }}>
              <Divider thickness={4} sx={{ borderBottomWidth: 5, borderColor: 'grey' }} />
            </Grid>
          </>
        )}
        {otherImgsHtml}
      </Grid>
    </>
  );
};

BracketImageOptionsUI.propTypes = {
  imagesData: PropTypes.array
};
